import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Icon from '../../Icon/Icon';
import SocialmediaFacebook from '../../../assets/svg/SocialmediaFacebook.svg';
import SocialmediaTwitter from '../../../assets/svg/SocialmediaTwitter.svg';
import SocialmediaPinterest from '../../../assets/svg/SocialmediaPinterest.svg';
import InstagramLine from '../../../assets/svg/InstagramLine.svg';
import SocialmediaYoutube from '../../../assets/svg/SocialmediaYoutube.svg';
import SocialmediaBlog from '../../../assets/svg/SocialmediaBlog.svg';
import { dt } from '../../../helpers/Utils/GetTailwindToken';

/**
 * Social Icon component to display social icons
 * Examples of using social Icons
 *  <SocialShare  iconClass="social-share" socialShareIcons={["FACEBOOK", "TWITTER", "GOOGLEPLUS"]}/>
 */

const iconMapping = {
    'socialmedia-twitter': <SocialmediaTwitter />,
    'instagram-line': <InstagramLine />,
    'socialmedia-facebook': <SocialmediaFacebook />,
    'socialmedia-pinterest': <SocialmediaPinterest />,
    'socialmedia-youtube': <SocialmediaYoutube />,
    'socialmedia-blog': <SocialmediaBlog />,
};

class SocialShare extends Component {
    /**
     * PropTypes to Indicate types of each Props for the entire component
     * Supported React properties
     * @type {Object}
     */
    static propTypes = {
        /**
         * Array of social icons that has to be shown
         * Takes following Values
         * FACEBOOK, TWITTER, GOOGLEPLUS, PINTEREST
         */
        socialShareIcons: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),

        /**
         * Space seperated classes for the component
         */
        iconClass: PropTypes.string,

        /**
         * Unique name for referencing dom element in automation testing
         * @type {String}
         */
        automationId: PropTypes.string,
        /**
         * For rendering <a> with some other renderer (like <Link/> component)
         */
        AnchorComponent: PropTypes.func,
    };

    static defaultProps = {
        socialShareIcons: [],
        iconClass: '',
        automationId: '',
        AnchorComponent: 'a',
    };

    onSocialShareClicked(event, AnchorComponent, linkPath) {
        // if using default <a> tag, do not redirect through <Link />
        if (AnchorComponent !== 'a') {
            event.preventDefault();
            return {
                url: linkPath, // redirect through <Link />
                openInNewTab: true,
            };
        }
        return null;
    }

    render() {
        const { socialShareIcons, iconClass, automationId, AnchorComponent } = this.props;
        const socialShareIconClasses = dt([
            'socialShareIcons',
            'cursor-pointer',
            ...iconClass.split(' '),
        ]);

        return (
            <div className="display-inline-b">
                {socialShareIcons.map((data, index) => {
                    const { linkPath, text = '', iconName } = data;
                    const socialIndex = index;

                    return (
                        <AnchorComponent
                            href={linkPath}
                            target="_blank"
                            onClick={
                                /* istanbul ignore next */
                                (event) =>
                                    this.onSocialShareClicked(event, AnchorComponent, linkPath)
                            }
                            data-automation-id={automationId}
                            className={dt([
                                'socialAnchor',
                                'no-underline',
                                'text-black',
                                'mr-2',
                                'md:mr-3',
                                'inline-block',
                                'last:mr-0',
                            ])}
                            key={socialIndex}
                            aria-label={`Icon - External Link ${text}`}
                            rel="noopener noreferrer"
                        >
                            <Icon
                                automationId={`icon-${automationId}`}
                                iconType="svg"
                                width="36px"
                                height="36px"
                                viewBox="0 0 36 36"
                                classNames={socialShareIconClasses}
                            >
                                {iconMapping[iconName]}
                            </Icon>
                        </AnchorComponent>
                    );
                })}
            </div>
        );
    }
}

export default SocialShare;
